/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseWhatsAppConfig } from '../../models/api-response-whats-app-config';

export interface GetWhatsAppConfigByPhone$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  phoneReference: string;
}

export function getWhatsAppConfigByPhone(http: HttpClient, rootUrl: string, params: GetWhatsAppConfigByPhone$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseWhatsAppConfig>> {
  const rb = new RequestBuilder(rootUrl, getWhatsAppConfigByPhone.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('phoneReference', params.phoneReference, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseWhatsAppConfig>;
    })
  );
}

getWhatsAppConfigByPhone.PATH = '/v1/api/ui/company/config/{phoneReference}';
